import { FC, useEffect, useState } from 'react'
import { useLocation } from 'react-router'

import { ArrowUpOutlined } from '@ant-design/icons'
import { FloatButton } from 'antd'
import { useResponsive } from 'antd-style'

const ScrollRestoration: FC = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

const ScrollToTop: FC = () => {
  const { mobile } = useResponsive()
  const [position, setPosition] = useState(window.scrollY)
  useEffect(() => {
    window.addEventListener('scroll', () => {
      setPosition(window.pageYOffset)
    })
  }, [])

  return position > 200 ? (
    <FloatButton
      icon={<ArrowUpOutlined />}
      type={'primary'}
      style={{
        zIndex: 999,
        right: mobile ? 20 : 36,
        bottom: mobile ? 84 : 114,
      }}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    />
  ) : null
}

export { ScrollRestoration, ScrollToTop }
